import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, Label, ButtonGroup, Button, Collapse } from 'reactstrap';
import Navigation from '../../components/Navigation/Navigation';
import { setBpi, setBpiSelected } from '../../actions/applicationAction';
import PageValidation from '../../components/PageValidation/PageValidation';
import withBackgroundImage from '../../HOC/withBackgroundImage';
import BpiModal from './BpiModal';

import './BalanceProtection.scss';

import FaAngleDown from 'react-icons/lib/fa/angle-down';
import FaAngleUp from 'react-icons/lib/fa/angle-up';

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  dataLayer: {
    pageCategory: 'Balance Protection',
    event: 'Credit Card Step 5B'
  }
}

class BalanceProtection extends Component {
  constructor(props) {
    super(props);

    this.buttonRef = React.createRef();
    this.state = {
      bpi: this.props.application.bpiSelected ? (this.props.application.bpi !== null && this.props.application.bpi !== '' && this.props.application.bpi === true ? true : false) : null,
      expand: false,
      showPageError: false,
      errorMessage: "",
      modalOpen: false,
      showModal: false
    }

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.expandToggle = this.expandToggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.modalToggle = this.modalToggle.bind(this);
    this.onClickYesBpi = this.onClickYesBpi.bind(this);
  }

  componentDidMount() {
    TagManager.dataLayer(tagManagerArgs);
  }

  onClickForward(event) {
    event.preventDefault();
    if (this.state.bpi === null || this.state.bpi === '' || this.state.bpi === undefined) {
      this.setState({
        showPageError: true,
        errorMessage: "Oops, we need to know whether you'd like to add balance protection insurance"
      });
    }
    else {
      this.props.setBpiSelected();
      this.props.setBpi(this.state.bpi);
      this.props.history.replace('/Review');
    }
  }
  onClickBackward(event) {
    event.preventDefault();

    // If there are auth users, redirect to the edit auth users screen
    if (this.props.authUsers.length > 0) {
      this.props.history.replace('/AuthorizedUsers/Add');
    }
    else {
      this.props.history.replace('/AuthorizedUsers');
    }
  }

  onClick(event) {
    event.preventDefault();
    if (event.target.name === 'yes') {
      this.setState({
        showModal: true,
        modalOpen: true
      });
    }
    else if (event.target.name === 'no') {
      this.setState({
        bpi: false,
        showPageError: false,
        modalOpen: false,
        showModal: false
      });
    }

  }

  onClickYesBpi() {
    document.getElementById('btn-yes').style.border = '2px solid #24abb4;'
    this.setState({
      bpi: true,
      modalOpen: false,
      showModal: false,
      showPageError: false
    });
  }

  closeModal() {
    document.getElementById('btn-yes').style.border = '2px solid #ebe8db;'
    this.setState({
      modalOpen: false,
      bpi: '',
      showModal: false
    });
  }

  toggle() {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  }

  modalToggle() {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  }

  expandToggle() {
    this.setState({
      expand: !this.state.expand
    })
  }

  render() {
    let expand = <div className="expand" onClick={this.expandToggle}><div>more</div><FaAngleDown /></div>;
    if (this.state.expand) {
      expand = <div className="expand" onClick={this.expandToggle}><div>less</div><FaAngleUp /></div>
    }
    console.log(this.state.bpi)
    return (
      <div className="bpi">
        <h1>Want to add optional balance protection insurance<sup>+</sup> ?</h1>
        <p>Life happens. Get balance protection insurance on this Visa account so your finances are protected when the unexpected happens. Coverage includes monthly payment assistance in the event of disability, job loss or strike and assistance with paying off your total outstanding balance in the event of death, critical illness or accidental dismemberment/paraplegia.</p>
        <p>No premium is charged if your account does not have a balance. If you carry a balance a monthly premium rate of $0.83 per $100 of the outstanding balance would be charged to your credit card.</p>
        <p>Click on more to learn about the coverage details.</p>
        <div className="display-more-separator">
          {expand}
        </div>
        <Collapse isOpen={this.state.expand} className="expanded-content">
          <h3>What's included:</h3>
          <ul>
            <li>If your earnings are interrupted by disability, job loss or strike, a monthly payment representing 5% of your outstanding balance on your credit card statement will be made to your account. </li>
            <li>In the event of death, diagnosis of an insured critical illness or accidental dismemberment/paraplegia, a lump sum payment will be made based on your outstanding account balance up to a maximum of $25,000.</li>
          </ul>
          <h3>What it costs:</h3>
          <ul>
            <li>No premium is charged if your account does not have a balance.</li>
            <li>Monthly premium rate of $0.83 per $100 of the outstanding balance on your credit card. For example if your monthly balance is $500, you will pay $4.15 per month.</li>
          </ul>
          <h3>Eligibility:</h3>
          <ul>
            <li>The primary cardholder of the Visa account. </li>
            <li>Self-employed individuals are not eligible for job loss or strike insurance.</li>
            <li>Disability, job loss or strike, life and Accidental Dismemberment/Paraplegia maximum enrollment age is 69 years of age.</li>
            <li>Critical Illness maximum is enrollment age is 59 years of age.</li>
            <li>All coverage terminates at 70 years of age.</li></ul>
          <p>For full eligibility and details  <a href="https://www.vancity.com/CreditCards/Benefits/OptionalProtection/CU_Credit_Protection_Product_Guide_Vancity_2021-12-13.pdf" target="_blank" rel="noopener noreferrer">refer to the policy</a>.</p>
        </Collapse>
        <Form onSubmit={this.onClickForward}>
          <FormGroup>
            <Label for="addBpi">Add balance protection insurance?</Label>
            <ButtonGroup>
              <Button id="btn-yes" className={(this.state.bpi === true) ? "active" : ""} name="yes" ref={this.buttonRef} onClick={this.onClick}>Yes</Button>
              <Button className={(this.state.bpi === false) ? "active" : ""} name="no" onClick={this.onClick}>No</Button>
            </ButtonGroup>
          </FormGroup>
          <PageValidation visible={this.state.showPageError} message={this.state.errorMessage} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
        {this.state.showModal && <BpiModal onClickYesBpi={this.onClickYesBpi} closeModal={this.closeModal} toggle={this.modalToggle} isOpen={this.state.modalOpen} />}
        <p className="footnote"><sup>+</sup>Creditor&apos;s group insurance is optional and is underwritten by Co-operators Life insurance Company. Supporting services, such as enrolment intake, medical underwriting and claims administration, are provided by the employees of CUMIS services Incorporated, a subsidiary of Co-operators Life insurance Company. Coverage is governed by the terms and conditions of the creditor group insurance policy issued to the creditor and is subject to terms, conditions, exclusions and eligibility requirements. See the Product Guide and Certificate of insurance for full Coverage details.</p>
      </div>);
  }
}

const mapStateToProps = state => ({
  authUsers: state.authUsers,
  application: state.application
});

const mapDispatchToProps = dispatch => ({
  setBpi: (bpi) => dispatch(setBpi(bpi)),
  setBpiSelected: () => dispatch(setBpiSelected())
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("bpi")(BalanceProtection));


// WEBPACK FOOTER //
// ./src/containers/BalanceProtection/BalanceProtection.js